import React, { useState } from "react";
import { InputNumberPadrao, LoadingIcon, ModalPadrao, ObsIcon, PrestadorIcon, SemDados, TagIcon } from "../../components/Base";
import toLocale from "../../Utils/ToLocaleString";
import { Input, Tooltip } from "antd";
import { BtnDeletar, BtnGravar, BtnLink, BtnSair } from "../../components/Buttons";
import roundCustom from "../../Utils/RoundCustom";
import { InputNumero } from "../../components/InputNumero";
import { EditarLoteIcon } from "../../Contexts/ProdutoLoteContext";
import InputBlur from "../../components/InputBlur";
import ModalDescontoPromocao from "./ModalDescontoPromocao";
import Mensagens from "../../components/Mensagens";
import culture from "../../Utils/Culture";

export default function TabelaBalcao({ prodList, onChangeQtd, onChangePreco, onChangeDesconto, onChangeObs, toggleTipoDesconto, onDelete, linhaMarcada, setLinhaMarcada, totais, onLimparClick, onConsultaClick, online, validarUsuario, validandoUsuario, permiteAlterarPreco, permiteDiminuirQuantidade, onChangeLote, formatarPrdPromo, disabled }) {
  const [produtoObs, setProdutoObs] = useState(null);
  const [produtoDesconto, setProdutoDesconto] = useState(null);

  return <div style={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column', border: "1px solid #ddd", marginTop: 10, borderRadius: 10 }}>
    {prodList.length ? <>
      <div style={{ flex: 1, overflow: "auto" }} id="tabelabalcao">
        <div className="tabela-wrapper-balcao" >
          <table className="tabela-padrao">
            <thead>
              <th style={{ textAlign: "initial" }}>Código</th>
              <th style={{ textAlign: "initial" }}>Descrição</th>
              <th style={{ textAlign: "right" }}>Quantidade</th>
              <th style={{ textAlign: "right" }}>Valor unitário</th>
              <th style={{ textAlign: "right" }}>Desconto</th>
              <th style={{ textAlign: "right" }}>Total líquido</th>
              <th style={{ textAlign: "right" }}></th>
              {!!prodList.find(s => s.pendente) && <th style={{ textAlign: "right" }}></th>}
            </thead>
            <tbody>
              {prodList.map((x, inx) => {
                const inputDescComunsProps = {
                  id: `input-tabelabalcao-desc-${inx}`,
                  onKeyDown: e => {
                    if (e.key === "ArrowLeft") {
                      var doc = document.querySelector(`#input-tabelabalcao-qtd-${inx}`);
                      if (doc) doc.focus();
                    };
                  },
                  onPressEnter: e => {
                    var doc = document.querySelector(`#input-tabelabalcao-qtd-${inx + 1}`);
                    if (doc) {
                      doc.focus();
                      setLinhaMarcada(inx + 1);
                    }
                    else e.target.blur();
                  },
                  onChange: v => onChangeDesconto(v, x),
                  style: { width: 90, visibility: x.descontoPromocao?.tipo != "Quantidade" ? null : 'hidden' },
                  disabled: x.pendente || x.descontoPromocao?.id || !!x?.descontoPromocaoAutorizacao || disabled
                };

                const inputQtdProps = {
                  precision: x.isFracionado ? 2 : 0,
                  type: "lowernumber",
                  id: `input-tabelabalcao-qtd-${inx}`,
                  onKeyDown: e => {
                    if (e.key === "ArrowRight") {
                      var doc = document.querySelector(`#input-tabelabalcao-${permiteAlterarPreco ? "prec" : "desc"}-${inx}`);
                      if (doc) doc.focus();
                    };
                  },
                  onPressEnter: () => {
                    var doc = document.querySelector(`#input-tabelabalcao-${permiteAlterarPreco ? "prec" : "desc"}-${inx}`);
                    if (doc) doc.focus();
                  },
                  min: 0.01,
                  disabled: x.disableQtd || x.pendente || !!x?.descontoPromocaoAutorizacao || disabled,
                  value: x.qtd,
                  onChange: v => {
                    if (permiteDiminuirQuantidade || v >= x.qtd)
                      onChangeQtd(v, x);
                    else
                      validarUsuario("DiminuirQuantidadeItensVenda", "Quantidade alterada", () => onChangeQtd(v, x));
                  },
                  style: { width: 90 }
                };

                return <tr key={inx}
                  onClick={() => {
                    if (linhaMarcada === inx) setLinhaMarcada(null);
                    else setLinhaMarcada(inx);
                  }}
                  className={linhaMarcada === inx ? "row-selected" : null}>
                  <td style={{ paddingLeft: 5 }}>
                    {x.codigo}
                    <Tooltip placement="bottom" title={x.isServico ? `Serviço${!!x.prestadorId?.length ? `: ${x.prestadorId[0].codigo} - ${x.prestadorId[0].nome}` : ""}` : null}>
                      <PrestadorIcon style={{ marginLeft: 5, fontSize: 15, visibility: x.isServico ? null : 'hidden' }} />
                    </Tooltip>
                  </td>

                  <td style={{ paddingLeft: 5 }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                      {x.descricao}
                      <Tooltip placement="bottom" title="Observação">
                        <ObsIcon style={{ margin: "0 10px", fontSize: 15 }} onClick={() => setProdutoObs(x)} />
                      </Tooltip>
                      <EditarLoteIcon onClick={() => onChangeLote(x)} qtd={x.qtd + (x?.qtdExtra || 0)} lotes={x.lotes} isLote={x.isLote} />
                    </div>
                  </td>

                  <td style={{ textAlign: "right" }}>
                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                      {(permiteDiminuirQuantidade || validandoUsuario) ? <InputNumberPadrao  {...inputQtdProps} /> : <InputBlur {...inputQtdProps} />}
                      <div style={{ position: 'relative' }}>
                        <Tooltip placement="bottom" title="Quantidade extra">
                          <span style={{ visibility: !!x.qtdExtra ? null : 'hidden', left: 10, top: -5, textAlign: 'left', position: "absolute" }}>{x.qtdExtra}</span>
                        </Tooltip>
                      </div>
                    </div>
                  </td>

                  <td style={{ textAlign: "right" }}>
                    <Tooltip placement="bottom" title={!x.pendente ? `Valor un. líquido: ${toLocale((x.valorTotal / x.qtd))} ` : null}>
                      <InputNumberPadrao
                        precision={2}
                        disabled={x.pendente || !permiteAlterarPreco || disabled}
                        id={`input-tabelabalcao-prec-${inx}`}
                        onKeyDown={e => {
                          if (e.key === "ArrowRight") {
                            var doc = document.querySelector(`#input-tabelabalcao-desc-${inx}`);
                            if (doc) doc.focus();
                          };
                        }}
                        onPressEnter={() => {
                          var doc = document.querySelector(`#input-tabelabalcao-desc-${inx}`);
                          if (doc) doc.focus();
                        }}
                        min={0.01}
                        value={x.valorUn}
                        onChange={v => onChangePreco(v, x)}
                        style={{ width: 90 }} />
                    </Tooltip>
                  </td>

                  <td style={{ textAlign: "right" }}>
                    {!x.pendente && <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                      {!!x.promocoes?.length && <Tooltip placement="bottom" title="Selecionar Desconto/Promoção">
                        <TagIcon className={!!x?.descontoPromocao?.id ? "row-verde" : "row-amarelo"} style={{ fontSize: 15, marginRight: 5 }} onClick={() => !x?.descontoPromocaoAutorizacao ? setProdutoDesconto(x) : Mensagens.showWarning("Este produto já tem uma promoção autorizada!")} />
                      </Tooltip>}

                      {x.isValor ? <InputNumero precision={2} value={x.desconto} min={0} showCurrency={false} {...inputDescComunsProps} /> :
                        <InputNumberPadrao precision={2} value={x.descPorc} min={0} max={100} {...inputDescComunsProps} />}

                      <Tooltip placement="bottom" title={`Trocar para ${(x.isValor ? 'percentual' : 'valor')}`}>
                        <span onClick={() => toggleTipoDesconto(x)} className="cor-azul" style={{ fontSize: 15, width: 10, marginLeft: 5, cursor: "pointer", visibility: !x.qtdExtra ? "visible" : "hidden" }}>{(x.isValor ? "$" : "%")}</span>
                      </Tooltip>
                    </div>}
                  </td>

                  <td style={{ textAlign: "right" }}>
                    <Tooltip placement="bottom" title={<>
                      <p style={{ margin: 0 }}>Total bruto: {toLocale(roundCustom(x.qtd * x.valorUn))}</p>
                      <p style={{ margin: 0 }}>Total desconto: {toLocale(roundCustom(x.qtd * x.valorUn - x.valorTotal))}</p>
                    </>}>
                      {toLocale(x.valorTotal)}
                    </Tooltip>
                  </td>
                  {x.pendente && <td style={{ paddingRight: 5, textAlign: "right" }}>
                    <LoadingIcon />
                  </td>}
                  <td className="td-icon" style={{ textAlign: "right", paddingRight: 5, visibility: disabled ? "hidden" : "visible" }}>
                    <BtnDeletar small onOk={() => { onDelete(x); setLinhaMarcada(0); }} disableModal />
                  </td>
                </tr>;
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div>
        <table className="tabela-padrao">
          <tfoot>
            <tr style={{ borderBottom: 0, borderTop: "1px solid #d6d6d6" }}>
              <td style={{ color: "#999", fontWeight: "initial", paddingLeft: 5 }}>
                <BtnLink disabled={!online} onClick={onConsultaClick}> F2 - Estoque/Obs</BtnLink>
              </td>
              <td style={{ color: "#999", fontWeight: "initial" }}>
                <BtnLink onClick={onLimparClick}>F6 - Limpar</BtnLink>
              </td>
              <td style={{ textAlign: "right", padding: "0 60px" }}>Totais itens: {culture.format(totais.itens)}</td>
              <td style={{ textAlign: "right" }}>Bruto: {toLocale(totais.bruto)}</td>
              <td style={{ textAlign: "right" }}>Desconto: {toLocale(totais.desconto)}</td>
              <td style={{ textAlign: "right", paddingRight: 5 }}>Líquido: {toLocale(totais.liquido)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </> : <SemDados style={{ marginTop: 100 }} />}

    <ModalPadrao title={`Observação: ${produtoObs?.codigo} - ${produtoObs?.descricao}`} visible={!!produtoObs}
      footer={<>
        <BtnGravar onClick={() => { onChangeObs(produtoObs); setProdutoObs(null); }} />
        <BtnSair onClick={() => setProdutoObs(null)} />
      </>}
      closable={false}
      width={window.innerWidth < 850 ? window.innerWidth : 850}
    >
      {!!produtoObs && <Input.TextArea placeholder="Insira a observação" style={{ height: 350 }}
        value={produtoObs.obs}
        onChange={v => setProdutoObs({ ...produtoObs, obs: v.target.value })}
      />}
    </ModalPadrao>

    <ModalDescontoPromocao produto={produtoDesconto} onOk={descontoPromocao => {
      onChangeQtd(produtoDesconto.qtd, produtoDesconto, descontoPromocao);
      setProdutoDesconto(null);
    }} onCancel={() => setProdutoDesconto(null)} formatarPrdPromo={formatarPrdPromo} />
  </div>;
}

